export const alertConstants = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING:'warning',
  CLOSE_ALERT: 'close_alert'
}